module.exports = __webpack_public_path__ + "assets/e1c4c8e0240acbe1171fcab884ebcc3d.png";